import {BaseAPI} from "@/api/BaseAPI";
import {Sentry} from "@/service/Sentry";

const SupplierAPI =  {

    API: BaseAPI,
    DOMAIN: 'suppliers',

    getAll() {
        return this.API.get(this.DOMAIN);
    },

    get(id) {
        return this.API.get([this.DOMAIN, id]);
    },

    getByIco(ico) {
        return this.API.get([this.DOMAIN, 'by-ico', ico]);
    },

    create(data) {
        return this.API.post(this.DOMAIN, data);
    },

    undoCreateFn(id, resolve, reject) {
        return () => {
            return this.API.delete([this.DOMAIN, id])
                .then(resolve)
                .catch(err => {
                    Sentry.captureException(err);
                    reject();
                });
        };
    },

    update(id, data) {
        return this.API.patch([this.DOMAIN, id], data);
    },

    delete(id) {
        return this.API.delete(
            [this.DOMAIN, id],
            [this.DOMAIN, 'delete']
        );
    }
};

export {SupplierAPI};
